import { Comment } from "../../types/recording";
import { TinyUser } from "../../types/user";
import ContentPlaceholder from "../ContentPlaceholder";
import RecordingCommentItem from "./RecordingCommentItem";

interface TinyUserSelect extends TinyUser {
  checked?: boolean;
}

interface RecordingCommentsListProps {
  recordingId: number;
  comments: Comment[];
  audioLoaded: boolean;
  disableCommentPlay: boolean;
  shared?: boolean;
  onDeleteComment: (id: number) => void;
  onUpdateComment: (updatedComment: Comment) => void;
  onCommentMouseOver: (commentId: number) => void;
  onCommentMouseOut: () => void;
  fetchLabelKeyTranslation: (key: string, defaultVal: string) => string;
  platformCallDetailId?: string;
  internalUsers: TinyUserSelect[];
  recordingPath: string;
  setTotalCommentsTemp: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
  totalCommentsTemp?: number;
  highlightedCommentId: number;
}

const RecordingCommentsList: React.FC<RecordingCommentsListProps> = ({
  recordingId,
  comments,
  audioLoaded,
  disableCommentPlay,
  shared,
  onDeleteComment,
  onUpdateComment,
  onCommentMouseOver,
  onCommentMouseOut,
  fetchLabelKeyTranslation,
  platformCallDetailId,
  internalUsers,
  recordingPath,
  setTotalCommentsTemp,
  totalCommentsTemp,
  highlightedCommentId,
}) => {
  return (
    <div className="col-md-7 mb-2">
      <div className="chat-bx h-100">
        <div className="chat-conversation h-100">
          {comments && comments.length === 0 && (
            <ContentPlaceholder>
              {fetchLabelKeyTranslation(
                "NoCommentDisplayMessage",
                "There are no comments for this call."
              )}
            </ContentPlaceholder>
          )}
          <div
            className="chatBox h-100 scroller w-100"
            style={{ maxHeight: "310px", overflow: "auto" }}
          >
            <ul className="list-unstyled mb-0">
              {/* Map through all the recording comments. */}
              {comments &&
                comments.map((item) => {
                  return (
                    <li
                      id={item.id.toString()}
                      key={item.id}
                      className={
                        item.id === highlightedCommentId
                          ? "comment-highliter"
                          : ""
                      }
                    >
                      <RecordingCommentItem
                        recordingId={recordingId}
                        comment={item}
                        audioLoaded={audioLoaded}
                        disableCommentPlay={disableCommentPlay}
                        onDeleteComment={onDeleteComment}
                        onUpdateComment={onUpdateComment}
                        onCommentMouseOver={onCommentMouseOver}
                        onCommentMouseOut={onCommentMouseOut}
                        shared={shared}
                        fetchLabelKeyTranslation={fetchLabelKeyTranslation}
                        platformCallDetailId={platformCallDetailId}
                        internalUsers={internalUsers}
                        recordingPath={recordingPath}
                        setTotalCommentsTemp={setTotalCommentsTemp}
                        totalCommentsTemp={totalCommentsTemp}
                      />
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordingCommentsList;
